import { defineMessages } from 'react-intl';

export default defineMessages({
  amountAvailableDetails: {
    id: 'sentinel.components.amountAvailablePanel.amountAvailableDetailsCaps',
    defaultMessage: 'Amount Available Details',
  },
  startDayCashAvailable: {
    id: 'sentinel.components.amountAvailablePanel.startDayCashAvailable',
    defaultMessage: 'Start Of Day Cash Available',
  },
  pendingDebitInterest: {
    id: 'sentinel.components.amountAvailablePanel.pendingDebitInterest',
    defaultMessage: 'Pending Debit Interest',
  },
  pendingDebitDividends: {
    id: 'sentinel.components.amountAvailablePanel.pendingDebitDividends',
    defaultMessage: 'Pending Debit Dividends',
  },
  fullyPaidUnsettledFunds: {
    id: 'sentinel.components.amountAvailablePanel.fullyPaidUnsettledFunds',
    defaultMessage: 'Fully Paid Unsettled Funds',
  },
  amountRecentDepositThreshold: {
    id: 'sentinel.components.amountAvailablePanel.amountRecentDepositThreshold',
    defaultMessage: 'Recent Deposit Threshold',
  },
  totalDisbursements: {
    id: 'sentinel.components.amountAvailablePanel.totalDisbursements',
    defaultMessage: 'Total Disbursements',
  },
  totalDeposits: {
    id: 'sentinel.components.amountAvailablePanel.totalDeposits',
    defaultMessage: 'Total Deposits',
  },
  amountAvailable: {
    id: 'sentinel.components.amountAvailablePanel.amountAvailable',
    defaultMessage: 'Amount Available',
  },
  notApplicableForDeposits: {
    id: 'sentinel.components.amountAvailablePanel.notApplicableForDeposits',
    defaultMessage: 'N/A for Deposits',
  },
});



// WEBPACK FOOTER //
// ./src/components/AmountAvailablePanel/messages.js